import { Grid } from "@mui/material";

import Helpers from "../../commons/helpers";
import Strings from "../../constants/strings";

import { Mode } from "../../constants/enums";
import Button from "../Button";
import Box from "../Box";

interface IProps {
    mode: Mode;
    isEdited: boolean;
    hidenActionBack?: boolean;
    hidenActionUpdate?: boolean;
    hidenActionCreate?: boolean;
    onGoBack: () => void;
    onSubmit: () => void;
}

const HeaderButton: React.FC<IProps> = ({ mode, isEdited, hidenActionBack, hidenActionCreate, hidenActionUpdate, onGoBack, onSubmit }) => {
    return (
        <Grid item xs={12}>
            <Box sx={{ display: "flex", alignItems: "flex-end", justifyContent: "end", mb: 2 }}>
                {!hidenActionBack && Helpers.isFunction(onGoBack) && (
                    <Button
                        color={"secondary"}
                        onClick={() => {
                            if (isEdited) {
                                Helpers.showConfirmAlert(Strings.Common.CANCEL_ACTION_MESSAGE, onGoBack);
                            } else {
                                onGoBack();
                            }
                        }}
                    >
                        {Strings.Common.GO_BACK}
                    </Button>
                )}
                {!hidenActionUpdate && [Mode.Update, Mode.View].includes(mode) && (
                    <Button sx={{ ml: 1 }} color={"dark"} onClick={onSubmit}>
                        {mode === Mode.View ? Strings.Common.EDIT : Strings.Common.SAVE}
                    </Button>
                )}
                {!hidenActionCreate && mode === Mode.Create && (
                    <Button sx={{ ml: 1 }} color={"dark"} onClick={onSubmit}>
                        {Strings.Common.SAVE}
                    </Button>
                )}
            </Box>
        </Grid>
    );
};

export default HeaderButton;
